import { ProfileType } from '@modules/search/types'
import { Shortlist } from '@modules/shortlist/types'

import { AlertFrequencyType, ProfileAlert } from '../types'
import { getApiClient } from './apiClient'

export const createProfileAlert = async ({
  profileAlerts,
  alertFrequency,
}: {
  profileAlerts: ProfileAlert[]
  alertFrequency?: AlertFrequencyType
}): Promise<void> => {
  const response = await getApiClient().post('/profiles', JSON.stringify({ profiles: profileAlerts, alertFrequency }))

  return response.data
}

export const fetchAlertsList = async (): Promise<Shortlist> => {
  const response = await getApiClient().get('/')

  return response.data
}

export const fetchProfilesAlerts = async (
  profiles: { id: number; '@type': ProfileType }[],
): Promise<{ profiles: ProfileAlert[] }> => {
  const response = await getApiClient().post(
    '/profiles/configured',
    JSON.stringify({ profiles: profiles.map(profile => ({ id: profile.id, type: profile['@type'] })) }),
  )

  return response.data
}

export const updateProfileAlert = async (profileAlert: ProfileAlert): Promise<void> => {
  const response = await getApiClient().put('/profiles', JSON.stringify({ profile: profileAlert }))

  return response.data
}

export const deleteProfilesAlerts = async (profiles: { id?: number | string; '@type'?: ProfileType }[]): Promise<void> => {
  const response = await getApiClient().delete('/profiles', {
    data: JSON.stringify({ profiles: profiles.map(profile => ({ id: profile.id, type: profile['@type'] })) }),
  })

  return response.data
}

export const updateProfileAlertViewed = async (profiles: { id: number | string; '@type': ProfileType }[]): Promise<unknown> => {
  const response = await getApiClient().put(
    '/profiles/viewed',
    JSON.stringify({ profiles: profiles.map(profile => ({ id: profile.id, type: profile['@type'] })) }),
  )

  return response.data
}

export const updateProfileAlertsAllViewed = async (): Promise<unknown> => {
  const response = await getApiClient().post('/profiles/viewed/all')

  return response.data
}

export const fetchNewAssets = async (params: { companyId?: number }): Promise<ViewedAssetsResponse> => {
  const { companyId } = params

  const { data } = await getApiClient().get(`/newAssets/viewed?companyId=${companyId}`)

  return data
}

export const updateViewedAssets = async (params: {
  companyId?: number
  viewedAssets: string[]
}): Promise<ViewedAssetsResponse> => {
  const { data } = await getApiClient().put('/newAssets/viewed', params)

  return data
}

export interface ViewedAssetsResponse {
  viewedAssets?: string[]
  alertCreatedAt?: string
}
